import { stripHtml } from "@/utils/stripHtml"
import { Anchor, Text, TextProps } from "@mantine/core"

interface LinkifiedTextProps extends Omit<TextProps, "children"> {
  content: string
}

export function LinkifiedText({ content, ...props }: LinkifiedTextProps) {
  const urlRegex = /(https?:\/\/[^\s]+|www\.[^\s]+)/g

  const parts = content?.split(urlRegex)

  return (
    <Text {...props}>
      {parts?.map((part, i) => {
        if (urlRegex.test(part)) {
          const href = part.startsWith("http") ? part : `https://${part}`
          return (
            <Anchor
              c={props.c}
              key={i}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
            >
              {part}
            </Anchor>
          )
        }
        return <div dangerouslySetInnerHTML={{ __html: stripHtml(part) }} />
      })}
    </Text>
  )
}
